import React from 'react';
import MuiCircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';

interface IProps extends CircularProgressProps {
  center?: boolean;
}

export default function CircularProgress(props: IProps) {
  const { color, size, thickness, variant, center } = props;

  const loadingComponent = (
    <MuiCircularProgress
      color={color}
      size={size}
      thickness={thickness}
      variant={variant}
    />
  );

  if (center) {
    return (
      <Grid item xs={12} container justifyContent="center">
        {loadingComponent}
      </Grid>
    );
  }

  return loadingComponent;
}
